import { render, staticRenderFns } from "./ItemPagination.vue?vue&type=template&id=975d428c&scoped=true"
import script from "./ItemPagination.vue?vue&type=script&lang=js"
export * from "./ItemPagination.vue?vue&type=script&lang=js"
import style0 from "./ItemPagination.vue?vue&type=style&index=0&id=975d428c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975d428c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('975d428c')) {
      api.createRecord('975d428c', component.options)
    } else {
      api.reload('975d428c', component.options)
    }
    module.hot.accept("./ItemPagination.vue?vue&type=template&id=975d428c&scoped=true", function () {
      api.rerender('975d428c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/browser/ItemPagination.vue"
export default component.exports